import React from 'react'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
// import CopyrightIcon from '@mui/icons-material/Copyright';
import Box from '@mui/material/Box';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';


function Copyright(props) {
    return (
      <Typography variant="body2" color="text.secondary" align="left" justifyItems="flex-start" alignItems="flex-start">
        {'Copyright © '}
        <Link color="inherit" target="_blank" href="https://beeitech.com/privacy_policy">
          YaYa Palyer
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }
const footbar_icon = [FacebookOutlinedIcon,YouTubeIcon,TwitterIcon,InstagramIcon]

export default function Footer() {
  return (
    <Box sx={{alignItems: 'right',display: 'flex', flexDirection: 'row',justifyContent:"space-between",marginLeft:'200px',height:"50px", backgroundColor:"white"}}>
        <Box>
        <Copyright sx={{ mt: 5 }} /> 
        </Box>
        <Box>
        {footbar_icon.map((Icon, index) => (
        <ListItemIcon key={index}>
          <Icon />
        </ListItemIcon>
      ))}
      </Box>
  </Box>
  )
}
